import { useQuery } from '@tanstack/react-query';
import { usersKeys } from '../users.keys';
import { getEligibleCommunities } from '../users.service';
export const useEligibleCommunities = (enabled = true) => {
    return useQuery({
        queryKey: usersKeys.eligibleCommunities(),
        queryFn: () => getEligibleCommunities(),
        enabled,
    });
};
